import { POPULATION_COLOR_PALETTES } from "@/lib/chartPalettes";

const P = POPULATION_COLOR_PALETTES;

export interface WordCloudPalette {
  id: string;
  label: string;
  colors: string[];
}

export const WORD_CLOUD_PALETTES: WordCloudPalette[] = [
  { id: "mix", label: "Mix", colors: [P.blue[700], P.teal[600], P.purple[600], P.blue[400], P.amber[600], P.slate[600]] },
  { id: "ocean", label: "Ocean", colors: [P.blue[800], P.teal[700], P.blue[600], P.teal[500], P.blue[400], P.slate[500]] },
  { id: "warm", label: "Warm", colors: [P.rose[700], P.amber[600], P.rose[500], P.amber[400], P.purple[600], P.slate[600]] },
  { id: "mono", label: "Monochrome", colors: [P.slate[900], P.slate[800], P.slate[700], P.slate[600], P.slate[500], P.slate[400]] },
  { id: "custom", label: "Custom", colors: [] },
];

export const WORD_CLOUD_MAX_WORDS = { min: 10, max: 150, default: 60 };

export const DEFAULT_WORD_CLOUD_PALETTE = "mix";

export function wordCloudColors(paletteId: string | undefined, custom: string[] | undefined): string[] {
  const palette = WORD_CLOUD_PALETTES.find((p) => p.id === paletteId) || WORD_CLOUD_PALETTES[0];
  if (palette.id === "custom") return WORD_CLOUD_PALETTES[0].colors.map((fallback, idx) => custom?.[idx] || fallback);
  return palette.colors;
}

export const WORD_CLOUD_CONTRASTS = [
  { value: "low", label: "Low", min: 16, max: 34 },
  { value: "medium", label: "Medium", min: 13, max: 52 },
  { value: "high", label: "High", min: 11, max: 76 },
];

export const DEFAULT_WORD_CLOUD_CONTRAST = "high";

export const WORD_CLOUD_LAYOUTS = [
  { value: "horizontal", label: "Horizontal", angles: [0] },
  { value: "mixed", label: "Horizontal and vertical", angles: [0, 0, 0, 90] },
  { value: "angled", label: "Angled", angles: [-45, 0, 0, 45] },
];

export const DEFAULT_WORD_CLOUD_LAYOUT = "horizontal";

export const WORD_CLOUD_COUNT_BY = [
  { value: "answer", label: "Whole answers" },
  { value: "word", label: "Words" },
];

export function wordCloudCountBy(countBy: string | undefined, cardType: string | undefined): string {
  return countBy || (cardType === "q_open_multiple" ? "answer" : "word");
}
